import dayjs, { Dayjs } from 'dayjs';
import { ISO8601 } from './model/ISO8601.ts';
import { State } from '@meraki-internal/state';

export class Clock extends State {

    private emitAt: ISO8601[] = [];

    private setEmitTimeouts = () => {
        for (const when of this.emitAt) {
            const msUntil = dayjs(when).diff(dayjs(this.now()));
            if (msUntil > 0) {
                setTimeout(() => this.setState({}), msUntil + 1);
            }
        };
    };

    now = () => Date.now();

    registerEmitAt = (...times: string[]) => {
        this.emitAt = [...this.emitAt, ...times];
        this.setEmitTimeouts();
    };

    // IOC.get('<Class>').clock.mock(time => time.add(15, 'days'))
    mock = (del: (time: Dayjs) => Dayjs) => {
        this.now = () => del(dayjs()).valueOf();
        this.setEmitTimeouts();
    };

    // IOC.get('<Class>').clock.mockFrom('2025-03-01T16:00:00.000Z')
    mockFrom = (time: ISO8601) => {
        const offset = dayjs().diff(time);
        this.now = () => dayjs().subtract(offset, 'ms').valueOf();
        this.setEmitTimeouts();
    };
};
